/* Keep one review embed and restore its original position at desktop widths. */
(() => {
  const initialised = new WeakSet();
  const setup = (scope = document) => {
    scope.querySelectorAll('product-info.hss-mobile-product').forEach((product) => {
      if (initialised.has(product)) return;
      initialised.add(product);
      const mobile = window.matchMedia('(max-width: 749px)');
      const review = product.querySelector('.hss-product-review');
      const info = product.querySelector('.product__info-container');
      const gallery = product.querySelector('media-gallery');
      if (!gallery) return;
      const home = review ? document.createComment('HSS desktop review position') : null;
      if (review) review.before(home);
      const description = product.querySelector('.product__description');
      const sections = [];
      const buildSections = () => {
        if (!description || sections.length) return;
        [...description.children].filter((heading) => /^H[2-6]$/.test(heading.tagName) && /^(fit|fabric|construction|details|sizing(?: and shrinkage)?|care)$/i.test(heading.textContent.trim())).forEach((heading, index) => {
          const contents = [];
          let next = heading.nextSibling;
          while (next && !(next.nodeType === 1 && /^H[2-6]$/.test(next.tagName))) {
            contents.push(next);
            next = next.nextSibling;
          }
          const body = document.createElement('div');
          body.id = `${product.id}-description-${index}`;
          body.className = 'hss-description-panel';
          body.hidden = true;
          const originalHeading = [...heading.childNodes];
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'hss-description-toggle';
          button.setAttribute('aria-expanded', 'false');
          button.setAttribute('aria-controls', body.id);
          const title = document.createElement('span');
          title.textContent = heading.textContent;
          const icon = document.createElement('span');
          icon.className = 'hss-description-icon';
          icon.setAttribute('aria-hidden', 'true');
          icon.textContent = '+';
          button.append(title, icon);
          button.addEventListener('click', () => {
            body.hidden = !body.hidden;
            button.setAttribute('aria-expanded', String(!body.hidden));
            icon.textContent = body.hidden ? '+' : '−';
          });
          heading.replaceChildren(button);
          heading.classList.add('hss-description-heading');
          heading.after(body);
          body.append(...contents);
          sections.push({ heading, body, originalHeading });
        });
      };
      const restoreSections = () => {
        sections.forEach(({ heading, body, originalHeading }) => {
          heading.replaceChildren(...originalHeading);
          heading.classList.remove('hss-description-heading');
          body.replaceWith(...body.childNodes);
        });
        sections.length = 0;
      };
      const layout = () => {
        if (mobile.matches) buildSections();
        else restoreSections();
        if (review && info) {
          if (mobile.matches) info.append(review);
          else home.after(review);
        }
      };
      // Keep native phone scrolling; add photo dragging to desktop thumbnail galleries.
      const viewer = gallery.querySelector('[id^="GalleryViewer"]');
      const galleryItems = () => [...viewer.querySelectorAll('.product__media-item')];
      const canDrag = () => !mobile.matches && gallery.dataset.desktopLayout.includes('thumbnail') && galleryItems().length > 1;
      if (gallery.dataset.desktopLayout.includes('thumbnail') && galleryItems().length > 1) {
        gallery.classList.add('hss-gallery-swipe');
        const hint = document.createElement('p');
        hint.className = 'hss-gallery-swipe-hint';
        hint.textContent = 'Drag left or right to browse · Click to zoom';
        viewer.after(hint);
      }
      let photoGesture = null;
      let suppressPhotoClickUntil = 0;
      const clearGesture = () => {
        const pointerId = photoGesture?.pointerId;
        photoGesture = null;
        viewer.classList.remove('hss-gallery-dragging');
        if (pointerId !== undefined && viewer.hasPointerCapture(pointerId)) viewer.releasePointerCapture(pointerId);
      };
      gallery.addEventListener('pointerdown', (event) => {
        clearGesture();
        suppressPhotoClickUntil = 0;
        if (!event.isPrimary || event.button !== 0 || !event.target.closest('.product__media-list .product__modal-opener--image')) return;
        photoGesture = { pointerId: event.pointerId, x: event.clientX, y: event.clientY, moved: false, dragging: false };
      });
      gallery.addEventListener('pointermove', (event) => {
        if (!photoGesture || event.pointerId !== photoGesture.pointerId) return;
        const dx = event.clientX - photoGesture.x;
        const dy = event.clientY - photoGesture.y;
        if (Math.hypot(dx, dy) > 10) photoGesture.moved = true;
        if (!canDrag() || (!photoGesture.dragging && (Math.abs(dx) < 12 || Math.abs(dx) < Math.abs(dy) * 1.2))) return;
        photoGesture.dragging = true;
        viewer.classList.add('hss-gallery-dragging');
        if (!viewer.hasPointerCapture(event.pointerId)) viewer.setPointerCapture(event.pointerId);
        event.preventDefault();
      });
      gallery.addEventListener('pointerup', (event) => {
        if (!photoGesture || event.pointerId !== photoGesture.pointerId) return;
        const dx = event.clientX - photoGesture.x;
        const dy = event.clientY - photoGesture.y;
        const threshold = Math.max(32, Math.min(72, viewer.clientWidth * 0.1));
        const navigate = canDrag() && photoGesture.dragging && Math.abs(dx) >= threshold && Math.abs(dx) > Math.abs(dy) * 1.2;
        if (photoGesture.moved) suppressPhotoClickUntil = Date.now() + 500;
        clearGesture();
        if (!navigate) return;
        const items = galleryItems();
        const current = items.findIndex((item) => item.classList.contains('is-active'));
        const next = current + (dx < 0 ? 1 : -1);
        if (current < 0 || next < 0 || next >= items.length) return;
        gallery.setActiveMedia(items[next].dataset.mediaId, false);
      });
      gallery.addEventListener('pointercancel', () => {
        if (photoGesture) suppressPhotoClickUntil = Date.now() + 500;
        clearGesture();
      });
      viewer.addEventListener('lostpointercapture', clearGesture);
      gallery.addEventListener('dragstart', (event) => {
        if (canDrag() && event.target.closest('.product__media-list .product__modal-opener--image')) event.preventDefault();
      });
      gallery.addEventListener('click', (event) => {
        // Pointer capture can retarget the release click to the gallery itself.
        if (event.detail !== 0 && Date.now() < suppressPhotoClickUntil) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);
      layout();
      mobile.addEventListener('change', layout);
      mobile.addEventListener('change', clearGesture);
      // Preserve the current image if the visitor rotates across the breakpoint.
      gallery.addEventListener('slideChanged', (event) => {
        if (!mobile.matches || !event.detail.currentElement || !event.target.id.startsWith('GalleryViewer')) return;
        gallery.querySelectorAll('.product__media-item').forEach((item) => {
          item.classList.toggle('is-active', item === event.detail.currentElement);
        });
      });
    });
  };
  setup();
  document.addEventListener('shopify:section:load', () => setup());
})();


/* One size-guide renderer shared by desktop and mobile. */
(() => {
  const ready = new WeakSet();
  const setupGuides = () => document.querySelectorAll('.product-popup-modal').forEach((modal) => {
    if (ready.has(modal)) return;
    const dialog = modal.querySelector('[role="dialog"]');
    if (!/size guide/i.test(dialog?.getAttribute('aria-label') || '')) return;
    const info = modal.querySelector('.product-popup-modal__content-info');
    const sources = [...info.querySelectorAll('table')];
    if (sources.length !== 2) return;
    const matrices = sources.map((table) => [...table.rows].map((row) => [...row.cells].map((cell) => cell.textContent.trim())));
    if (matrices.some((rows) => rows.length < 2 || rows.some((row) => row.length !== rows[0].length))) return;
    const title = info.querySelector('h1, h2');
    const notes = [...info.querySelectorAll('p')].filter((p) => !p.closest('table'));
    if (!title || matrices[0].length !== matrices[1].length || matrices[0][0].length !== matrices[1][0].length) return;
    ready.add(modal);
    modal.classList.add('hss-size-guide');
      const heading = title.cloneNode(true);
      const controls = document.createElement('div');
      controls.className = 'hss-size-units';
      controls.setAttribute('role', 'group');
      controls.setAttribute('aria-label', 'Measurement units');
      const scroll = document.createElement('div');
      scroll.className = 'hss-size-table-scroll';
      scroll.tabIndex = 0;
      scroll.setAttribute('role', 'region');
      scroll.setAttribute('aria-label', 'Size measurements. Scroll sideways for more sizes.');
      const table = document.createElement('table');
      table.className = 'hss-size-table';
      const caption = document.createElement('caption');
      const thead = document.createElement('thead');
      const tbody = document.createElement('tbody');
      table.append(caption, thead, tbody);
      scroll.append(table);
      // Display inches first; source tables remain centimetres, then inches.
      const units = [{ name: 'Inches', matrixIndex: 1 }, { name: 'Centimetres', matrixIndex: 0 }];
      const buttons = units.map(({ name, matrixIndex }) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = name;
        button.addEventListener('click', () => render(matrixIndex));
        controls.append(button);
        return button;
      });
      const render = (index) => {
        const matrix = matrices[index];
        caption.textContent = `Measurements in ${index ? 'inches' : 'centimetres'}`;
        buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(units[i].matrixIndex === index)));
        const header = document.createElement('tr');
        ['Website size', ...matrix.slice(1).map((row) => row[0])].forEach((value) => {
          const cell = document.createElement('th');
          cell.scope = 'col';
          if (value.endsWith(' (US)')) {
            cell.append(document.createTextNode(value.slice(0, -5)), document.createElement('br'), document.createTextNode('(US)'));
          } else cell.textContent = value;
          header.append(cell);
        });
        thead.replaceChildren(header);
        tbody.replaceChildren();
        for (let column = 1; column < matrix[0].length; column++) {
          const row = document.createElement('tr');
          const label = document.createElement('th');
          label.scope = 'row';
          label.textContent = matrix[0][column];
          row.append(label);
          matrix.slice(1).forEach((source) => {
            const cell = document.createElement('td');
            cell.textContent = source[column];
            row.append(cell);
          });
          tbody.append(row);
        }
      };
      const explanation = document.createElement('div');
      explanation.className = 'hss-size-notes';
      notes.forEach((note) => {
        const copy = note.cloneNode(true);
        copy.textContent = copy.textContent.replace('size guide below', 'size guide above');
        explanation.append(copy);
      });
      info.replaceChildren(heading, controls, scroll, explanation);
      render(1);
  });
  setupGuides();
  document.addEventListener('DOMContentLoaded', setupGuides, { once: true });
  document.addEventListener('shopify:section:load', setupGuides);
  // Modal content can be inserted after the product script has loaded.
  document.addEventListener('click', (event) => {
    if (event.target.closest('modal-opener')) setupGuides();
  }, true);
})();
